import React, { useState, useEffect } from 'react';
import axiosPost from '../helpers/axios-helper';
import '../styles/VenueButtons.css';

/**
 * The call-to-action buttons an editor set for a venue ("Reserve", "Call",
 * "Directions", ...). Renders nothing when there are none.
 */
export default function VenueButtons({ itemType, itemId }) {
  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    if (!itemId || !itemType) return undefined;
    const controller = new AbortController();
    axiosPost(
      'buttons/for-item',
      { 'Content-Type': 'application/json' },
      { item_type: itemType, item_id: itemId },
      (resp) => { if (resp?.success) setButtons(resp.data.buttons || []); },
      controller
    );
    return () => controller.abort();
  }, [itemType, itemId]);

  if (buttons.length === 0) return null;

  return (
    <div className='venue-buttons'>
      {buttons.map((b, i) => {
        const external = /^https?:/i.test(b.url);
        return (
          <a
            key={b.id}
            href={b.url}
            className={`venue-button ${i === 0 ? 'primary' : ''}`}
            {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          >
            {b.label}
          </a>
        );
      })}
    </div>
  );
}
